// This icon file is generated automatically.
var PImportOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M11.88 9.83h-.84a.12.12 0 00-.12.12v.97H1.08V1.08h9.84v.97c0 .06.05.12.12.12h.84c.07 0 .12-.06.12-.12V.48a.48.48 0 00-.48-.48H.48A.48.48 0 000 .48v11.04c0 .27.21.48.48.48h11.04c.27 0 .48-.21.48-.48V9.95a.12.12 0 00-.12-.12zm.21-4.4H7.2V4.26c0-.1-.12-.16-.2-.1L4.76 5.9a.12.12 0 000 .2l2.21 1.75c.09.06.2 0 .2-.1V6.56h4.91c.07 0 .13-.05.13-.12v-.88a.13.13 0 00-.13-.12z", "fill-rule": "nonzero" } }] }, "name": "p-Import", "theme": "outlined" };
export default PImportOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PImportOutlined.js
// module id = 3454
// module chunks = 0